import { Award, ShieldCheck, TrendingUp, Users } from "lucide-react";

const TRUST_BULLETS = ["Sem vínculo exclusivo", "100% independência", "Remuneração por resultado"];

/** Onda de barras decorativa — variação sutil do padrão visto no allugatorinvest.com. */
export const WaveBars = () => {
  const bars = Array.from({ length: 64 });
  return (
    <div
      aria-hidden
      className="absolute inset-x-0 bottom-0 h-40 sm:h-48 flex items-end gap-[3px] px-4 opacity-70"
      style={{
        maskImage: "linear-gradient(to bottom, transparent, black 70%)",
        WebkitMaskImage: "linear-gradient(to bottom, transparent, black 70%)",
      }}
    >
      {bars.map((_, i) => {
        const h = 20 + Math.sin((i / bars.length) * Math.PI) * 70;
        return (
          <div
            key={i}
            className="flex-1 rounded-full bg-[#323F4F]/[0.06]"
            style={{ height: `${h}%` }}
          />
        );
      })}
    </div>
  );
};

export const AssessoresHero = () => {
  return (
    <section className="relative bg-[#FAF8F5] overflow-hidden pt-8 sm:pt-14">
      <WaveBars />
      <div className="container-wide px-6 sm:px-6 md:px-12 pb-20 sm:pb-28 md:pb-32 relative">
        <div className="grid gap-14 lg:gap-10 lg:grid-cols-12 items-center">
          {/* Coluna esquerda — texto */}
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#34F285]/[0.06] pl-2 pr-4 py-1.5 text-xs font-medium text-[#1F3D2E] ring-1 ring-[#1F3D2E]/10">
              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-white text-[#2E694D]">
                <ShieldCheck className="w-3 h-3" />
              </span>
              Parceria para profissionais independentes
            </span>

            <h1
              className="mt-6 text-[#323F4F] font-extrabold leading-[1.18] tracking-tight text-[2.1rem] sm:text-[2.7rem] md:text-[3.1rem] max-w-2xl"
              style={{
                fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
              }}
            >
              Construa receita recorrente divulgando crédito estruturado, mantendo sua{" "}
              <span className="text-[#2E694D]">independência</span>.
            </h1>

            <p className="mt-6 text-lg sm:text-xl font-normal text-zinc-600 leading-relaxed max-w-xl">
              Se você é Consultor de Investimentos, Assessor Autônomo ou Educador
              Financeiro, a Allu oferece a estrutura de divulgação, compliance e
              suporte comercial para você ampliar seus ganhos — sem abrir mão da
              fidúcia, da autonomia e da confiança da sua carteira.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <a
                href="#form"
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#2E694D] hover:bg-[#255A41] text-[#FAFAFA] text-sm font-medium px-[18px] py-3.5 transition-colors"
              >
                Quero ser parceiro da Allu
              </a>
              <a
                href="#como-funciona"
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-transparent hover:bg-white text-[#323F4F] text-sm font-medium px-[18px] py-3.5 ring-1 ring-[#323F4F]/15 transition-colors"
              >
                Ver como funciona
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mt-9">
              {TRUST_BULLETS.map((b) => (
                <span
                  key={b}
                  className="inline-flex items-center gap-2 text-sm font-medium text-zinc-500"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-[#2E694D]" />
                  {b}
                </span>
              ))}
            </div>
          </div>

          {/* Coluna direita — cards flutuantes com os números reais da
              operação (sem foto de estoque: seguimos o padrão de "floating
              data cards" do allugatorinvest.com, com dados verdadeiros). */}
          <div className="lg:col-span-5 relative pb-16 sm:pb-20">
            <div
              aria-hidden
              className="absolute -inset-10 rounded-full bg-[radial-gradient(closest-side,rgba(52,242,133,0.16),transparent)]"
            />

            <div className="relative bg-white rounded-3xl shadow-[0_20px_60px_-15px_rgba(50,63,79,0.25)] p-6 sm:p-7">
              <div className="text-sm font-semibold text-[#323F4F]">
                Operação Allu
              </div>
              <div className="text-xs text-zinc-500 mt-0.5">
                Números que sustentam o programa de parceiros
              </div>

              <div className="mt-6 space-y-5">
                {[
                  { icon: TrendingUp, value: "10 anos", label: "de mercado" },
                  { icon: Users, value: "+60.000", label: "clientes ativos" },
                  { icon: ShieldCheck, value: "100%", label: "de adimplência" },
                ].map((s) => (
                  <div key={s.label} className="flex items-center gap-3.5">
                    <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-[#34F285]/[0.08] text-[#2E694D] shrink-0">
                      <s.icon className="w-4 h-4" />
                    </span>
                    <div className="flex items-baseline justify-between flex-1 gap-2">
                      <span
                        className="text-xl sm:text-2xl font-extrabold text-[#323F4F]"
                        style={{ fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif' }}
                      >
                        {s.value}
                      </span>
                      <span className="text-xs sm:text-sm text-zinc-500">{s.label}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative sm:absolute sm:bottom-0 sm:right-6 mt-4 sm:mt-0 bg-white rounded-2xl shadow-[0_16px_40px_-12px_rgba(50,63,79,0.25)] px-5 py-4 inline-flex items-center gap-3 max-w-[15rem]">
              <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-[#1F3D2E] text-[#D9BC7C] shrink-0">
                <Award className="w-4 h-4" />
              </span>
              <div>
                <div className="text-sm font-bold text-[#323F4F] leading-tight">
                  3ª maior do mundo
                </div>
                <div className="text-xs text-zinc-500">no segmento · CVM 88</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
